import { FC } from 'react';
import { useState } from '@hookstate/core';
import { useTranslation } from 'react-i18next';
import { MessageModal as MessageModalComponent } from '../../components/MessageModal';
import { meta, closeModal } from '../../stores/backend';

export const MessageModal: FC = () => {
    const { t } = useTranslation();

    const $meta = useState(meta);

    const modalName = $meta.modals.msgCommon.name.value;
    const message = t(modalName) || t('error.general');
    const closeBehavior = $meta.modals.msgCommon.closeBehavior.value || 'close';
    const hideCloseButton =
        $meta.modals.msgCommon.hideCloseButton.value || false;
    const showButton = $meta.modals.msgCommon.showButton.value || false;
    const buttonText = $meta.modals.msgCommon.buttonText.value;
    const buttonBehavior = $meta.modals.msgCommon.buttonBehavior.value;

    const onClose = () => closeModal('msgCommon');
    const handleReload = () => window.location.reload();
    const handleClose = closeBehavior === 'reload' ? handleReload : onClose;
    const handleButtonClick =
        buttonBehavior === 'reload' ? handleReload : undefined;

    return (
        <MessageModalComponent
            onClose={handleClose}
            message={message}
            isOpen={$meta.modals.msgCommon.isOpen.value}
            hideCloseButton={hideCloseButton}
            showButton={showButton}
            buttonText={buttonText ? t(buttonText) : undefined}
            onButtonClick={handleButtonClick}
        />
    );
};
